import { createAction, createSlice } from '@reduxjs/toolkit';

const handlePlacementMarginToolEmailCreation = createAction('HANDLE_PLACEMENT_MARGIN_TOOL_EMAIL');

export interface IPlacementMarginToolEmail {}

export const initialState: IPlacementMarginToolEmail = {};

const placementMarginToolEmailSlice = createSlice({
  name: 'placementMarginToolEmail',
  initialState: initialState,
  reducers: {
    reset() {
      return {
        ...initialState,
      };
    },
  },
});

const { actions } = placementMarginToolEmailSlice;

export const { name: placementMarginToolEmailSliceKey, reducer: placementMarginToolEmailReducer } =
  placementMarginToolEmailSlice;

export const placementMarginToolEmailAction = {
  ...actions,
  handlePlacementMarginToolEmailCreation: handlePlacementMarginToolEmailCreation,
};
